module.exports = __webpack_public_path__ + "media/images/producers/producers-pg-bg-06a5f6e909e05ae07511c25d3e7e7cee.jpg";